import { SORT_VIEW } from 'Common/enums';

function WithoutCompareSort(sortType?: string, chartTypeWiseSort?: SimulationPerformanceTableItem[]) {
    const sortData = chartTypeWiseSort?.length ? chartTypeWiseSort : [];
    if (sortType?.toString() === SORT_VIEW.HIGH) {
        return sortData.sort((a, b) => Number(b?.matches) - Number(a?.matches));
    }
    if (sortType?.toString() === SORT_VIEW.LOW) {
        return sortData.sort((a, b) => Number(a?.matches) - Number(b?.matches));
    }
    return sortData.sort((a: any, b: any) => a.rule.localeCompare(b.rule, { numeric: true }));
}
export default WithoutCompareSort;
